<div class="container-fluid">
  <h1 mat-dialog-title i18n>Edit Work Order Schedule</h1>
  <div mat-dialog-content>
    <p i18n>A work order assigns a crew to a quote area over a certain period of time.</p>
    <div>
      <span i18n>Project Name:</span> {{job.quote_Name}}
    </div>
    <div>
      <span i18n>Project Address:</span> {{job.quote_Address1}} {{job.quote_Address2}} {{job.quote_City}}, {{job.quote_State}} {{job.quote_Postal}}
    </div>
    <form #workOrderForm="ngForm" (ngSubmit)="updateWorkOrder(workOrderForm)">
      <div class="modal-body">
        <div class="form-group row">
          <label for="areas" class="col-sm-4 col-form-label" i18n>Areas</label>
          <div class="col-sm-8">
            <div *ngIf="workOrderAreas == null" i18n>Loading...</div>
            <ng-template ngFor let-area [ngForOf]="workOrderAreas">
              <div *ngFor="let quoteArea of area.quoteAreas">
                {{area.area_Name}} -
                <span *ngIf="quoteArea.acceptedItem.area_Name != null">{{quoteArea.acceptedItem.area_Name}}</span>
                <span *ngIf="quoteArea.acceptedItem.area_Name == null">{{quoteArea.acceptedItem.subArea.subArea_Name}}</span>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="form-group row">
          <label for="workOrderType_ID" class="col-sm-4 col-form-label">
            <span class="warning">* </span>
            <span i18n>Work Order Type</span>
          </label>
          <div class="col-sm-8">
            <select class="form-control select-bidit" name="workOrderType_ID"
                    [disabled]="data.readOnly"
                    required
                    [(ngModel)]="data.workOrder.workOrderType_ID" #workOrderType_ID="ngModel">
              <option [ngValue]="undefined">-</option>
              <option *ngFor="let workOrderType of data.workOrderTypes" [ngValue]="workOrderType.workOrderType_ID">{{workOrderType.workOrderType_Desc}}</option>
            </select>
            <div [hidden]="!workOrderForm.submitted || workOrderType_ID.valid"
                 class="alert alert-danger" i18n>Select a work order type</div>
          </div>
        </div>
        <div class="form-group row">
          <label for="workOrderStatus_ID" class="col-sm-4 col-form-label" i18n>Work Order Status</label>
          <div class="col-sm-8">
            <select class="form-control select-bidit" name="workOrderStatus_ID"
                    [disabled]="data.readOnly"
                    [(ngModel)]="data.workOrder.workOrderStatus_ID" #workOrderStatus_ID="ngModel">
              <option [ngValue]="undefined">-</option>
              <option *ngFor="let workOrderStatus of workOrderStatuses" [ngValue]="workOrderStatus">{{getWorkOrderStatusName(workOrderStatus)}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="workOrder_Instructions" class="col-sm-4 col-form-label" i18n>Instructions</label>
          <div class="col-sm-8">
            <textarea class="form-control" name="workOrder_Instructions"
                      [disabled]="data.readOnly"
                      rows="3"
                      [(ngModel)]="data.workOrder.workOrder_Instructions" #workOrder_Instructions="ngModel"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="selectedCrews" class="col-sm-4 col-form-label">
            <span class="warning">* </span>Crew Assigned
            <button type="button" mat-button
                    *ngIf="!data.readOnly"
                    (click)="customizeCrew()" class="btn btn-bidit-navigate" i18n>
              Customize
            </button>
          </label>
          <div class="col-sm-8">
            <mat-select multiple required class="form-control"
                        [disabled]="data.readOnly"
                        [(value)]="selectedCrews">
              <mat-option *ngFor="let crew of data.crews" [value]="crew">
                <div class="color-swatch"
                     [style.background-color]="crew.crew_Color">&nbsp;</div>
                {{crew.crew_Name}}
              </mat-option>
            </mat-select>
            <div class="warning" *ngIf="data.workOrder.workOrderCrewOverrides.length > 0" i18n>* MODIFIED</div>
            <div [hidden]="!workOrderForm.submitted || selectedCrews.length > 0"
                 class="alert alert-danger col-sm-12" i18n>Select Crew</div>
          </div>
        </div>
        <div class="form-group row">
          <label for="crew_ID" class="col-sm-4 col-form-label">
            <span i18n>Resources</span>
            <button type="button" mat-button
                    *ngIf="!data.readOnly"
                    (click)="editResources()" class="btn btn-bidit-navigate" i18n>
              Edit Resources
            </button>
          </label>
          <div class="col-sm-8">
            <p *ngIf="data.workOrder.workOrderResources.length == 0" i18n>No resources assigned to work order</p>
            <p *ngFor="let wor of data.workOrder.workOrderResources">{{wor.resource.resource_Name}}</p>
          </div>
        </div>
        <div class="form-group row">
          <label for="workOrder_Start" class="col-sm-4 col-form-label">
            <span class="warning">* </span>
            <span i18n>Start Date</span>
          </label>
          <div class="col-sm-4 form-inline">
            <input name="workOrder_Start" class="form-control narrow-input"
                   matInput
                   placeholder="mm/dd/yyyy"
                   required
                   [disabled]="data.readOnly"
                   [matDatepicker]="startPicker"
                   [(ngModel)]="data.workOrder.workOrder_Start" #workOrder_Start="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </div>
          <div class="col-sm-4">
            <select name="startTime" class="form-control select-bidit"
                    required
                    [disabled]="data.readOnly"
                    [(ngModel)]="data.startTime" #startTime="ngModel">
              <option value="">-</option>
              <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
            </select>
          </div>
          <div [hidden]="!workOrderForm.submitted || (workOrder_Start.valid && startTime.valid)"
               class="alert alert-danger col-sm-12" i18n>Enter a valid start date and time</div>
        </div>
        <div class="form-group row">
          <label for="workOrder_Stop" class="col-sm-4 col-form-label">
            <span class="warning">* </span>
            <span i18n>End Date</span>
          </label>
          <div class="col-sm-4 form-inline">
            <input name="workOrder_Stop" class="form-control narrow-input"
                   matInput
                   placeholder="mm/dd/yyyy"
                   required
                   [disabled]="data.readOnly"
                   [matDatepicker]="stopPicker"
                   [(ngModel)]="data.workOrder.workOrder_Stop" #workOrder_Stop="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="stopPicker"></mat-datepicker-toggle>
            <mat-datepicker #stopPicker></mat-datepicker>
          </div>
          <div class="col-sm-4">
            <select name="stopTime" class="form-control select-bidit"
                    required
                    [disabled]="data.readOnly"
                    [(ngModel)]="data.stopTime" #stopTime="ngModel">
              <option value="">-</option>
              <option *ngFor="let time of data.times" [ngValue]="time">{{time}}</option>
            </select>
          </div>
          <div [hidden]="!workOrderForm.submitted || (workOrder_Stop.valid && stopTime.valid)"
               class="alert alert-danger col-sm-12" i18n>Enter a valid end date and time</div>
        </div>
        <div class="form-group row">
          <label for="workOrder_IncludeWeekends" class="col-sm-4 col-form-label" i18n>Include Weekends</label>
          <div class="col-sm-8">
            <mat-radio-group area-label="Include Weekends" name="workOrder_IncludeWeekends" [disabled]="data.readOnly"
                             [(ngModel)]="data.workOrder.workOrder_IncludeWeekends">
              <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
              <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="form-group row">
          <label for="useSameTimesMultiDay" class="col-sm-4 col-form-label" i18n>Use Same Times Multi-Day</label>
          <div class="col-sm-8">
            <mat-radio-group area-label="Use Same Times Multi-Day" name="useSameTimesMultiDay" [disabled]="data.readOnly"
                             [(ngModel)]="data.workOrder.useSameTimesMultiDay">
              <mat-radio-button [value]="false" class="pr-2" i18n>No</mat-radio-button>
              <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4" for="crewColor" i18n>Custom Color</label>
          <input type="color" id="workOrder_Color" name="workOrder_Color" [disabled]="data.readOnly"
                 class="form-control col-sm-2" [(ngModel)]="data.workOrder.workOrder_Color">
        </div>
        <div [hidden]="timeAlert == null"
             class="alert alert-danger">
          {{timeAlert}}
        </div>
      </div>
      <div [hidden]="!workOrderForm.submitted || workOrderForm.valid"
           class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
      <div class="row" *ngIf="!data.readOnly">
        <div *ngIf="!isRequesting">
          <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
      <div *ngIf="data.readOnly">
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Close</button>
      </div>
    </form>
  </div>
</div>
